<template>
  <div>
    <NuxtLayout name="split">
      <ConnectifTag :name="CONNECTIF_PAGE_TAGS.TRAVELER" />

      <template #aside>
        <UIcon
          name="EscapadaLogoSmall"
          class="w-12 h-12 mb-6 text-white"
          aria-hidden="true"
        />

        <ul>
          <li
            v-for="(item, index) in asideTexts"
            :key="index"
            class="flex gap-x-2"
          >
            <TTitle
              size="4xl"
              color="text-white"
              :bold="true"
              leading="tight"
              classes="m-0"
            >
              {{ item }}
            </TTitle>
          </li>
        </ul>
      </template>
      <AuthLoginNew />
      <div class="text-center text-sm">
        <ULink :active="true" class="text-sm" @click="publishYourProperty()">{{
          t('auth.login.label2')
        }}</ULink>

        <TText classes="my-3 text-sm">{{
          t('auth.login.label-separator')
        }}</TText>

        <i18n-t keypath="auth.login.label" tag="span" scope="global">
          <template #register>
            <ULink
              :active="true"
              :href="routes().travelerRegistration()"
              external
              >{{ t('auth.login.register') }}</ULink
            >
          </template>
        </i18n-t>
      </div>
      <SSpacer />
    </NuxtLayout>
  </div>
</template>

<script setup lang="ts">
// Constants
import { CONNECTIF_PAGE_TAGS } from '~~/modules/integrations/connectif/constants'
import { sendConnectifPage } from '~~/modules/integrations/connectif/composables/useConnectifComposable'

// Composables
import { useMenuBreadcrumbStore } from '~~/modules/menu/stores/useMenuBreadcrumbStore'
import { useHeadInfoComposable } from '~~/modules/head/composables/useHeadInfoComposable'
import { sendGa4PublishYourPropertyClick } from '~~/modules/integrations/ga4/composables/useAnalyticsGa4Composable'

const { setHeadInfo } = useHeadInfoComposable()
const breadCrumbMenuStore = useMenuBreadcrumbStore()

breadCrumbMenuStore.setMenuBreadcrumb(t('menu.breadcrumb.login'))

definePageMeta({
  layout: false,
  splitImageUrl: '/__nuxt-public/images/registration/split-side.jpeg',
  splitImageAlt: 'views.login.pageMeta.splitImageAlt',
})

setHeadInfo({
  title: t('views.login.seo.title'),
  description: t('views.login.seo.description'),
  robotsVisible: true,
  images: [
    {
      url: '/__nuxt-public/images/registration/split-side.jpeg',
      alt: t('views.login.seo.title'),
    },
  ],
})

const asideTexts: Array<string> = [
  t('views.login.aside.text1'),
  t('views.login.aside.text2'),
  t('views.login.aside.text3'),
  t('views.login.aside.text4'),
]

const publishYourProperty = () => {
  sendGa4PublishYourPropertyClick({
    eventCallback: () => {
      navigateTo(routes().ownerRegistration(), { external: true })
    },
  })
}

onMounted(() => {
  const { isAndroid, isIos } = useDevice()
  isIos && window.webkit?.messageHandlers?.goToLogin?.postMessage('')
  isAndroid && window?.ERAndroid?.goToLogin()
})

sendConnectifPage()
</script>
